<template>
  <div id="app">
    <ErrorBoundary>
      <router-view />
    </ErrorBoundary>
  </div>
</template>

<script>
import ErrorBoundary from './components/errors/ErrorBoundary.vue';

export default {
  name: 'App',
  components: {
    ErrorBoundary
  }
};
</script>

<style>
@import './styles/themes.css';

#app {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--bg-primary);
  color: var(--text-primary);
}
</style>